// @ts-nocheck
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const NForm: StatelessFunctionalComponent<any> = styled.div`
  width: 100%;
`;
export default NForm;
